import { useSelector } from '@lingoda/hooks';
import { studentPreferencesSelector } from '@lingoda/students';

export const useSubscribeUnlockBanner = () => {
    const preferences = useSelector(studentPreferencesSelector);

    return preferences?.dismissedWidgets?.subscribeLingodaBanner === false;
};
